export default "__VITE_ASSET__B_LbEB2s__"